// Shared decimal helpers for document formulas and opportunity calc evaluators.

/** Coerce a value to a safe non-negative finite number. */
export function safeNumber(n: unknown): number {
  const v = typeof n === "number" ? n : Number(n);
  if (!Number.isFinite(v)) return 0;
  if (v < 0) return 0;
  return v;
}

/** Clamp a percentage to [0, 100]; non-finite -> 0. */
export function safePct(n: unknown): number {
  const v = typeof n === "number" ? n : Number(n);
  if (!Number.isFinite(v)) return 0;
  if (v < 0) return 0;
  if (v > 100) return 100;
  return v;
}

/** Round to 2 decimal places, returning a finite number (NaN -> 0). */
export function round2(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}
